import _default from './Statistic';
export { _default as default };